// ** React Imports
import {Link, Outlet} from 'react-router-dom'
import {useEffect, useState} from 'react'
import CompanyLogo from "../../pages/main/CompanyLogo"
import classnames from 'classnames'
import useScreenSize from '../../utility/hooks/useScreenSize'

const BlankConfirmLayout = () => {
    // ** States
    const [isMounted, setIsMounted] = useState(false)
    const {isMobile, screen} = useScreenSize()

    useEffect(() => {
        setIsMounted(true)
        return () => setIsMounted(false)
    }, [])

    if (!isMounted) {
        return null
    }

    return (
        <>
            <div className="auth-inner my-2">
                <div className="mb-0">
                    <div className="ui-loader text-center">
                        <Link className='brand-logo brand-logo-confirm' to='/' onClick={e => e.preventDefault()}>
                            <CompanyLogo/>
                        </Link>
                    </div>
                </div>
            </div>
            <div
                className={classnames('wrapper vertical-layout navbar-floating footer-static vertical-menu-modern menu-expanded', {
                    'mx-3': !isMobile && screen !== 'md',
                    'mx-0-75': isMobile,
                    'mx-1': screen === 'md'
                })}
                data-col="1-column">
                <div className="content overflow-hidden">
                    <div className="content-wrapper container-xxl p-0">
                        <div id="dashboard-ecommerce">
                            <Outlet/>
                        </div>
                    </div>
                </div>
                <div className="sidenav-overlay"></div>
            </div>
        </>
    )
}

export default BlankConfirmLayout
